export default __webpack_public_path__ + "static/media/rotate_left-24px.460c540f.svg";